import {
    LOADED_ACTION_LOGS,
    LOADED_ACTION_LOGS_CURRENT,
    LOADED_ACTION_LOGS_LIMIT,
    LOADED_ACTION_LOGS_PAGES,
    LOADED_ACTION_LOGS_TOTAL
} from "../actions/action_log_actions";

const searchParams = new URLSearchParams(location.search);

const action_logs = (payload = [], action) => {
    switch (action.type) {
        case LOADED_ACTION_LOGS:
            return action.payload;
        default:
            return payload;
    }
};
const action_logs_current = (payload = searchParams.has('current') ? parseInt(searchParams.get('current')) : 1, action) => {
    switch (action.type) {
        case LOADED_ACTION_LOGS_CURRENT:
            return action.payload;
        default:
            return payload;
    }
};
const action_logs_total = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_ACTION_LOGS_TOTAL:
            return action.payload;
        default:
            return payload;
    }
};
const action_logs_pages = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_ACTION_LOGS_PAGES:
            return action.payload;
        default:
            return payload;
    }
};
const action_logs_limit = (payload = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : 25, action) => {
    switch (action.type) {
        case LOADED_ACTION_LOGS_LIMIT:
            return action.payload;
        default:
            return payload;
    }
};

export default {
    action_logs,
    action_logs_current,
    action_logs_total,
    action_logs_pages,
    action_logs_limit
}